// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".src-HR-PersonTargets-Form-style__noValidationError--x33K\\+{display:none}.src-HR-PersonTargets-Form-style__validationError--CotKE{color:#fff;padding:1em 3em .01em 1em;margin:0 0 1.5em;position:relative;background:#d24444}.src-HR-PersonTargets-Form-style__validationError--CotKE ul{margin-bottom:1em;padding-left:1em}.src-HR-PersonTargets-Form-style__validationError--CotKE ul li{margin-bottom:.5em;list-style:disc}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"noValidationError": "src-HR-PersonTargets-Form-style__noValidationError--x33K+",
	"validationError": "src-HR-PersonTargets-Form-style__validationError--CotKE"
};
export default ___CSS_LOADER_EXPORT___;
